import { Component } from '@angular/core';

@Component({
  selector: 'app-after-logout',
  standalone: true,
  imports: [],
  templateUrl: './after-logout.component.html'
})
export class AfterLogoutComponent {}
